import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import './i18n';
import { LanguageProvider } from './context/LanguageContext';
import { SocialProvider } from './context/SocialContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <SocialProvider>
          <App />
        </SocialProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
